import i18n from "./i18LanguageTranslation/i18n";

export const getApiMessage = (code) => {
  return i18n.t(`errorCode.${String(code)}`, {
    defaultValue: i18n.t("common.somethingWentWrong"),
  });
};
